export const environment = {
  production: false,
  apiUrl: 'https://staging.manosya.api-gateway.innovax.cl',
  googleMapsApiKey: 'AIzaSyDEQJhHT2KWQ8Rm5X5o8BSOhJ-RPaohtOs',
  googleMapsMapId: 'e36dbe7bfbb5a6bba7078c38',
};
